import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import LoginService from '../api-services/login.service'
import { syncForOffline } from '../sync/sync'
// import clients from './modules/clients'
import createMutationsSharer from 'vuex-shared-mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    token: localStorage.getItem('user-token') || null,
    user: (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : null,
    status: null,
    userProductsOrder: {
      products: []
    },
    dataSyncing: false
  },
  getters: {
    isAuthenticated: state => !!state.token,
    user: state => state.user,
    authStatus: state => state.status,
    getUserProductsOrder: state => state.userProductsOrder,
    dataSyncing: state => state.dataSyncing
  },
  mutations: {
    UPDATE_SYNC_STATUS (state) {
      state.dataSyncing = true
    },
    REMOVE_PRODUCT (state, payload) {
      state.userProductsOrder.products = []
      Object.assign(state.userProductsOrder.products, payload)
    },
    RESET_ORDER (state, payload) {
      state.userProductsOrder.products = []
    },
    CHANGE_LOADING (state, payload) {
      state.loading = payload || false
    },
    CHANGE_ORDER_ROWS (state, payload) {
      console.log(payload)
      let obj = JSON.parse(JSON.stringify(payload))
      Object.assign(state.userProductsOrder, obj)
      // state.userProductsOrder = payload
    },
    CHANGE_USER_ORDER (state, payload) {
      let product = state.userProductsOrder.products.find(userProdOrder => userProdOrder.id === payload.object.id)
      if (product) {
        let wareh = product.warehouses.find(warehouse => parseInt(warehouse.id) === parseInt(payload.warehouse.id))
        wareh = JSON.parse(JSON.stringify(wareh))
        if (wareh) {
          for (var key in product.warehouses) {
            if (parseInt(product.warehouses[key].id) === parseInt(wareh.id)) {
              product.warehouses[key].qty += parseInt(payload.added)
              product.qty += parseInt(payload.added)
            }
          }
        } else {
          product.warehouses.push(payload.warehouse)
        }
      } else {
        state.userProductsOrder.products.push(payload.object)
      }
    },
    AUTH_REQUEST (state) {
      state.status = 'loading'
    },
    AUTH_SUCCESS (state, token) {
      state.status = 'success'
      state.token = token
    },
    AUTH_SET_USER (state, user) {
      state.user = user
    },
    AUTH_ERROR (state) {
      state.status = 'error'
    },
    AUTH_LOGOUT (state) {
      state.status = null
      state.token = null
      state.user = null
    }
  },
  actions: {
    startDataSync ({ dispatch, commit }) {
      commit('UPDATE_SYNC_STATUS')
    },
    removeProduct ({ dispatch, commit }, payload) {
      commit('REMOVE_PRODUCT', payload)
    },
    clearProductsFromOrder ({ dispatch, commit }) {
      commit('RESET_ORDER')
    },
    orderRow ({ dispatch, commit }, payload) {
      commit('CHANGE_ORDER_ROWS', payload)
    },
    showLoading ({ dispatch, commit }) {
      commit('CHANGE_LOADING', true)
      dispatch('adjustLoadingContainer')
    },
    addProduct ({ commit, getters }, payload) {
      commit('CHANGE_USER_ORDER', payload)
    },
    hideLoading (state) {
      state.commit('CHANGE_LOADING', false)
    },
    authRequest ({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        commit('AUTH_REQUEST')
        LoginService.login(user)
          .then((response) => {
            const token = response.data.data.access_token
            localStorage.setItem('user-token', token) // store the token in localstorage
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('AUTH_SUCCESS', token)
            // you have your token, now log in your user :)
            // dispatch('userRequest')
            resolve(dispatch('userRequest'))
          })
          .catch((error) => {
            console.log(error)
            commit('AUTH_ERROR', error)
            localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
            reject(error)
          })
      })
    },
    userRequest ({ commit, dispatch }) {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        LoginService.getAuthUser()
          .then((response) => {
            const user = response.data.data
            localStorage.setItem('user', JSON.stringify(user)) // store the token in localstorage
            commit('AUTH_SET_USER', user)
            commit('UPDATE_SYNC_STATUS')
            syncForOffline()
            resolve(response)
          })
          .catch((error) => {
            console.log(error.response)
            dispatch('logoutRequest')
            reject(error)
          })
      })
    },
    logoutRequest ({ commit, dispatch }) {
      document.cookie = 'synced=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
      return new Promise((resolve, reject) => {
        commit('AUTH_LOGOUT')
        localStorage.removeItem('user-token') // clear your user's token from localstorage
        localStorage.removeItem('user') // clear your user's token from localstorage
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    adjustLoadingContainer () {
      let scrollerContainer = document.getElementsByClassName('loading-spinner')[0]
      let navbar = document.getElementsByClassName('navbar')[0]
      if (scrollerContainer) {
        let doc = document.documentElement
        let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
        if (navbar) {
          top = (top < navbar.offsetHeight) ? top : (navbar.offsetHeight || 0)
        }
        // set offsets
        scrollerContainer.style.marginTop = '-' + top + 'px'
        if (screen.width <= 850) {
          scrollerContainer.style.marginTop = '0px'
        } else {
          scrollerContainer.style.marginTop = '-' + top + 'px'
        }
      }
    },
    toggleMenu () {
      let bodyCheck = document.body
      let windowWidth = window.innerWidth
      let ordersSlideout = document.getElementById('orders-slideout')
      let productSlideout = document.getElementById('product-slideout')
      let offersSlideout = document.getElementById('offers-slideout')
      let burger = document.querySelector('.burger')
      let activeButtons = document.querySelectorAll('.action-button')
      let wrapper = document.getElementById('wrapper')
      let innerWrapper = document.getElementById('page-content-wrapper')
      let slideoutGroup = [ordersSlideout, productSlideout, offersSlideout]
      for (let i = 0; i < slideoutGroup.length; i++) {
        if (slideoutGroup[i] && slideoutGroup[i].classList.contains('slideout-open')) {
          slideoutGroup[i].classList.remove('slideout-open')
          activeButtons[i].classList.remove('action-button-active')
        }
      }
      innerWrapper.classList.remove('changed-position')
      wrapper.classList.toggle('toggled')
      burger.classList.toggle('open_burger')
      if (windowWidth <= 768) {
        bodyCheck.classList.remove('set-overflow')
      }
    }
  },
  plugins: [createMutationsSharer({ predicate: ['CHANGE_ORDER_ROWS', 'RESET_ORDER', 'REMOVE_PRODUCT'] })],

  modules: {
    // clients
  }
})
